// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import getWorkshopDataActions from './getWorkshopDataActions';
import getWorkshopContentsDataActions from './getWorkshopContentsDataActions';
import getWorkshopNotesDataActions from './getWorkshopNotesDataActions';
import createWorkshopNoteActions from './createWorkshopNoteActions';
import { updateWorkshopNoteActions } from './updateWorkshopNoteActions';
import { deleteWorkshopNoteActions } from './deleteWorkshopNoteActions';
import updateWorkshopProgressActions from './updateWorkshopProgressActions';

export default {
  getWorkshopDataActions,
  getWorkshopContentsDataActions,
  getWorkshopNotesDataActions,
  createWorkshopNoteActions,
  updateWorkshopNoteActions,
  deleteWorkshopNoteActions,
  updateWorkshopProgressActions
}
